import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

Vue.use(Vuex)

const vuexPersist = new VuexPersist({
  key: 'spinosa',
  storage: localStorage
})

export default new Vuex.Store({
  state: {
      deliveries : [],
      mp_code: '',
      batchraw: '',
      analisi: [],
      rawmplist: [],
      trasformazione: [],
      confezionamento: [],
      distribuzione: [],
      loadedData: [],
      delivery: [],
      batchlist: [],
      access_token: '',
      error_loading: []
  },
  getters: {
    ERRORLOADING_GET: state => {
      return state.error_loading
    },    
    MP_CODE_GET: state => {
      return state.mp_code
    },
    BATCHRAW_GET: state => {
      return state.batchraw
    },
    DELIVERIES_GET: state => {
      return state.deliveries
    },
    ANALISI_GET: state => {
      return state.analisi
    },
    DELIVERY_GET: state => {
      return state.delivery
    },
    TRASFORMAZIONE_GET: state => {
      return state.trasformazione
    },
    CONFEZIONAMENTO_GET: state => {
      return state.confezionamento
    },
    DISTRIBUZIONE_GET: state => {
      return state.distribuzione
    },
    RAWMPLIST_GET: state => {
      return state.rawmplist
    },
    BATCHLIST_GET: state => {
      return state.batchlist
    },
    LOADEDDATA_GET: state => {
      return state.loadedData
    },
    GET_ACCESSTOKEN: state => {
      return state.access_token
    }
  },
  mutations: {
    LOGIN: (state, payload) => {
      localStorage.setItem('access_token', payload) 
      state.access_token = payload
    },
    LOGOUT: (state) => {
      state.access_token = ''
      state.loadedData = []
      state.conferimento = []
      state.deliveries = []
      state.batchlist = []
      state.rawmplist = []
      state.batchraw = ''
      state.mp_code = ''
      localStorage.removeItem('access_token')
      localStorage.removeItem('spinosa')
    },
    CONFERIMENTO_SET: (state, payload) => {
      if (payload.deliveries) {
      state.deliveries = payload.deliveries
      }
      if (payload.code) {
      state.mp_code = payload.code
      }
      if (payload.batchraw) {
        state.batchraw = payload.batchraw
      }
    },
    CONFERIMENTO_PUSH: (state, payload) => {
      state.conferimento.push(payload)
    },
    DELIVERY_SET: (state, payload) => {
      state.delivery.push(payload)
    },
    ANALISI_SET: (state, payload) => {
      state.analisi.push(payload)
    },
    TRASFORMAZIONE_SET: (state, payload) => {
      state.trasformazione.push(payload)
    },
    RAWMPLIST_FETCH: (state, payload) => {
      state.rawmplist = payload
    },
    BATCHLIST_FETCH: (state, payload) => {
      state.batchlist = payload
    },
    CONFEZIONAMENTO_SET: (state, payload) => {
      state.confezionamento.push(payload)
    },
    DISTRIBUZIONE_SET: (state, payload) => {
      state.confezionamento.push(payload)
    },
    ERRORLOADING_SET: (state, payload) => {
      if (payload.length > 0) {
      state.error_loading.push(payload)
      }
    },
    ERRORLOADING_CANCEL: (state, payload) => {
      state.error_loading = payload
    },
    CONFERIMENTO_EXCEL: (state, payload) => {
      state.loadedData = payload
    },
  },
  actions: {
    async update_errorloading(context, payload) {
      context.commit('ERRORLOADING_SET', payload);
    },    
    async remove_errorloading(context, payload) {
      context.commit('ERRORLOADING_CANCEL', payload);
    },    
    async login(context,payload) {
      context.commit('LOGIN', payload)
    },
    async logout(context) {
      context.commit('LOGOUT')
    },
    async update_conferimento(context, payload) {
      context.commit('CONFERIMENTO_SET', payload);
    },
    async push_conferimento(context, payload) {
      context.commit('CONFERIMENTO_PUSH', payload);
    },
    async update_analisi(context, payload) {
      context.commit('ANALISI_SET', payload);
    },
    async update_confezionamento(context, payload) {
      context.commit('CONFEZIONAMENTO_SET', payload);
    },
    async update_trasformazione(context, payload) {
      context.commit('TRASFORMAZIONE_SET', payload);
    },
    async update_distribuzione(context, payload) {
      context.commit('DISTRIBUZIONE_SET', payload);
    },
    async update_delivery(context, payload) {
      context.commit('DELIVERY_SET', payload);
    },
    async update_excel(context, payload) {
      context.commit('CONFERIMENTO_EXCEL', payload);
    }
  
},
  plugins: [vuexPersist.plugin]
})